import React from 'react';
import { Github, Linkedin } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { translations } from '../translations/translations';
import '../styles/Footer.css';

export default function Footer() {
    const { language } = useAppContext();
    const t = translations[language];

    return (
        <footer className="footer">
            <div className="container footer__inner">
                <p className="footer__copyright">{t.footer.copyright}</p>
                <div className="footer__social">
                    <a
                        href="https://github.com/Mertozkaya21"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="GitHub"
                        className="footer__link"
                    >
                        <Github size={16} />
                    </a>
                    <a
                        href="https://www.linkedin.com/in/mertozkaya1"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        className="footer__link"
                    >
                        <Linkedin size={16} />
                    </a>
                </div>
            </div>
        </footer>
    );
}
